import React, { useState, useEffect } from "react";
import { Progress, Tooltip } from "antd";
import "./ProgressBar.css";

const ProgressBar = ({ percent }) => {
  const [animatedPercent, setAnimatedPercent] = useState(0);

  useEffect(() => {
    requestAnimationFrame(() => {
      setAnimatedPercent(percent);
    });
  }, [percent]);

  return (
    <div className="progress-bar-wrapper">
      <Tooltip title={`${animatedPercent}% en progreso`}>
        <Progress
          percent={animatedPercent}
          showInfo={false}
          className="my-progress-bar"
          strokeColor="#00DD9E"
          trailColor="#DADEE3"
          strokeWidth={5}
          strokeLinecap="round"
        />
      </Tooltip>
    </div>
  );
};

export default ProgressBar;
